<template>
  <div>
    <NavBar />
    <div class="container">
      <SideBar />
      <div class="content">
        <div class="content-wrapper">
          <Loading :isActive="loading"></Loading>
          <h1 class="title">
            <svg
              version="1.1"
              id="Capa_1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              viewBox="0 0 23.48 23.48"
            >
              <path
                d="M13.008,23.247h-2.434c-0.464,0-0.598,0-1.862-3.128l-0.843-0.343 c-2.598,1.179-2.91,1.179-3.044,1.179c-0.172,0-0.365-0.075-0.486-0.196l-1.721-1.685c-0.343-0.338-0.431-0.425,0.934-3.521 l-0.34-0.803C0,13.601,0,13.462,0,12.981v-2.385c0-0.477,0-0.599,3.201-1.838l0.34-0.805C2.1,4.916,2.199,4.818,2.545,4.477 l1.724-1.685C4.39,2.674,4.583,2.599,4.753,2.599c0.125,0,0.45,0,3.092,1.115l0.838-0.341c1.175-3.141,1.324-3.141,1.789-3.141 h2.434c0.463,0,0.598,0,1.861,3.13l0.842,0.34c2.596-1.176,2.908-1.176,3.044-1.176c0.171,0,0.363,0.074,0.484,0.192 l1.725,1.683c0.336,0.331,0.431,0.425-0.934,3.523l0.339,0.808c3.213,1.147,3.213,1.285,3.213,1.764v2.384 c0,0.478-0.001,0.601-3.203,1.841l-0.338,0.805c1.442,3.035,1.342,3.134,0.999,3.475l-1.728,1.688 c-0.122,0.119-0.314,0.193-0.484,0.193l0,0c-0.123,0-0.446,0-3.088-1.117l-0.842,0.341 C13.621,23.247,13.484,23.247,13.008,23.247z M10.924,21.945h1.725c0.23-0.492,0.673-1.604,1.029-2.562 c0.063-0.171,0.196-0.308,0.365-0.376l1.357-0.55c0.159-0.064,0.34-0.063,0.499,0.005c0.976,0.415,2.129,0.879,2.651,1.055 l1.208-1.184c-0.194-0.512-0.684-1.596-1.119-2.509c-0.079-0.167-0.084-0.361-0.013-0.533l0.559-1.328 c0.069-0.163,0.201-0.292,0.366-0.354c0.983-0.38,2.127-0.849,2.628-1.087v-1.656c-0.507-0.226-1.642-0.656-2.618-1.003 c-0.173-0.061-0.312-0.191-0.383-0.361l-0.559-1.33c-0.069-0.166-0.068-0.353,0.005-0.517c0.418-0.943,0.884-2.058,1.067-2.577 l-1.209-1.181c-0.518,0.187-1.641,0.671-2.589,1.104c-0.161,0.074-0.349,0.079-0.514,0.011l-1.357-0.548 c-0.163-0.066-0.295-0.197-0.36-0.361c-0.387-0.963-0.864-2.083-1.108-2.571H10.83c-0.231,0.493-0.673,1.605-1.028,2.562 C9.74,4.266,9.606,4.404,9.437,4.471l-1.353,0.55c-0.161,0.065-0.34,0.064-0.5-0.004C6.608,4.602,5.451,4.138,4.93,3.965 L3.722,5.147C3.917,5.66,4.404,6.744,4.84,7.659c0.08,0.167,0.083,0.361,0.012,0.533L4.29,9.519 c-0.069,0.163-0.2,0.291-0.365,0.354C2.942,10.252,1.8,10.719,1.3,10.957v1.657c0.505,0.228,1.641,0.659,2.618,1.007 c0.172,0.062,0.311,0.193,0.381,0.36l0.558,1.327c0.07,0.165,0.067,0.351-0.004,0.515c-0.418,0.944-0.884,2.059-1.067,2.577 l1.208,1.182c0.517-0.188,1.64-0.672,2.589-1.104c0.162-0.074,0.348-0.078,0.514-0.012l1.357,0.551 c0.165,0.066,0.294,0.196,0.359,0.36C10.202,20.34,10.68,21.459,10.924,21.945z M11.74,15.87c-2.319,0-4.207-1.854-4.207-4.13 c0-2.275,1.888-4.127,4.207-4.127c2.318,0,4.205,1.852,4.205,4.127C15.945,14.016,14.058,15.87,11.74,15.87z M11.74,8.914 c-1.602,0-2.905,1.268-2.905,2.826c0,1.561,1.303,2.829,2.905,2.829s2.904-1.269,2.904-2.829 C14.644,10.181,13.342,8.914,11.74,8.914z"
              />
            </svg>
            Configurações
          </h1>
          <ul class="tabs">
            <li>
              <router-link to="/">Dados</router-link>
            </li>
            <li>
              <router-link to="/logo">Logo</router-link>
            </li>
            <li>
              <router-link to="/footer">Logo rodapé</router-link>
            </li>
            <li class="tab-active">
              <router-link to="/avancado">Avançado</router-link>
            </li>
          </ul>
          <div class="card">
            <div class="card-body">
              <div v-if="error" class="text-error">{{ error.message || error.statusText }}</div>
              <SMTP :smtp="smtp" :onSubmit="changeSmtpConfig" :checkSmtp="checkSmtp"/>
              <br />
              <br />
              <MeLigue :meLigue="meLigue" :onSubmit="changeMeLigue" />
              <br />
              <br />
              <Senha :onSubmit="changePassword" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { post, put, get } from "@/helpers/apiRequest";
import Senha from "./Senha";
import SMTP from "./SMTP";
import MeLigue from "./MeLigue";

const urlSenha = `/usuario/senha`;
const urlSmtp = `/smtp`;
const urlMeLigue = `/me-ligue`;

export default {
  components: {
    Senha,
    SMTP,
    MeLigue
  },
  name: "configAvancado",
  data() {
    return {
      loading: false,
      error: null,
      smtp: {
        server: "",
        user: "",
        pass: "",
        port: ""
      },
      meLigue: {
        url: "",
        apiKey: ""
      }
    };
  },
  methods: {
    changeSmtpConfig({ smtp }) {
      this.loading = true;
      put(urlSmtp, { smtp })
        .then(res => {
          if (res.error) {
            this.$swal({ title: res.message, type: "error" });
          } else {
            this.$swal({ title: res.message, type: "success" });
          }
        })
        .catch(err => {
          this.$swal({ title: err.message, type: "error" });
        })
        .finally(() => {
          this.loading = false;
          this.fetchSmtp();
        });
    },
    changeMeLigue(meLigue) {
      this.loading = true;
      put(urlMeLigue, meLigue)
              .then(res => {
                if (res.error) {
                  this.$swal({ title: res.message, type: "error" });
                } else {
                  this.$swal({ title: res.message, type: "success" });
                }
              })
              .catch(err => {
                this.$swal({ title: err.message, type: "error" });
              })
              .finally(() => {
                this.loading = false;
                this.fetchMeLigue();
              });
    },
    changePassword({ senhaAtual, senhaNova }) {
      this.loading = true;
      post(urlSenha, { senhaAtual, senhaNova })
        .then(res => {
          if (res.error) {
            this.$swal({ title: res.message, type: "error" });
          } else {
            this.$swal({ title: res.message, type: "success" });
          }
        })
        .catch(err => {
          this.$swal({ title: err.message, type: "error" });
        })
        .finally(() => (this.loading = false));
    },

    fetchSmtp() {
      this.loading = true;
      this.error = null;
      get(urlSmtp)
        .then(json => {
          this.smtp = Object.assign({}, json.smtp);
        })
        .catch(err => {
          this.error = err;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    fetchMeLigue() {
      this.loading = true;
      this.error = null;
      get(urlMeLigue)
              .then(json => {
                this.meLigue = Object.assign({}, json.meLigue);
              })
              .catch(err => {
                this.error = err;
              })
              .finally(() => {
                this.loading = false;
              });
    },
    checkSmtp({ smtp }) {
      this.loading = true;
      post('/check-smtp', smtp)
              .then(res => {
                this.$swal({ title: res.message, type: "success" });
              })
              .catch(err => {
                this.$swal('Ops, confira o erro abaixo:', err.message, "error");
              })
              .finally(() => this.loading = false);
    }
  },
  beforeMount() {
    this.fetchSmtp();
    this.fetchMeLigue();
  }
};
</script>



// WEBPACK FOOTER //
// src/views/Config/Avancado/Avancado.vue